import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';

const iconStyle = css`
  &:has(> .highlight:checked) {
    background-color: ${colors['@primary-color-dark']};
    border-color: ${colors['@primary-color-dark']};
  }
`;

const radioConfig: ConfigProviderProps['radio'] = { classNames: { icon: iconStyle } };

export default radioConfig;
